<template>
    <asli-quote-declined title="Session expired">
        <p class="text-center">Your session has expired, please return to the form and try again.</p>
    </asli-quote-declined>
    <asli-divider class="my-[30px]" />
    <div class="text-center md:text-left">
        <asli-button id="session-expired-return-homepage" color="primary" class="mb-[30px]" @click="goHome">
            Return to Homepage
        </asli-button>
    </div>
</template>

<script lang="ts" setup>
import { AsliDivider, AsliQuoteDeclined, AsliButton } from "@mbs-npm/anpost-ui";
import router from "@/router";
import { FormRouteName } from "@/router/utils";
import { FORM_MODE, ROUTE_NAMES } from "@/router/types";

function goHome() {
    router.push({ name: FormRouteName(ROUTE_NAMES.AboutYou, FORM_MODE.CREATE) }).catch(() => {});
}
</script>
